// Grafana Frontend Observability (Faro) collector URL per VUE_APP_ENV.
// These URLs are public by design. An environment without an entry sends no browser telemetry.
const faroCollectorUrls: Record<string, string> = {
  dev1: "https://faro-collector-prod-ap-southeast-1.grafana.net/collect/b6e844f1324e15707ebe592b30b78244",
  prod: "https://faro-collector-prod-ap-southeast-1.grafana.net/collect/b6e844f1324e15707ebe592b30b78244",
};

export const config = {
  appEnv: process.env.VUE_APP_ENV,
  appVersion: process.env.VUE_APP_VERSION,
  faroUrl: faroCollectorUrls[process.env.VUE_APP_ENV ?? ""] as
    | string
    | undefined,
};
